(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.add('js');
  const nav = $('#nav'); let lastY = 0;
  addEventListener('scroll', () => {
    const y = scrollY;
    nav.classList.toggle('is-scrolled', y > 10);
    nav.classList.toggle('is-hidden', y > 600 && y > lastY + 4 && !nav.classList.contains('menu-open') && !nav.querySelector('.dd.is-open'));
    if (y < lastY - 4) nav.classList.remove('is-hidden');
    lastY = y;
  }, { passive: true });

  /* ---------- Nav dropdowns + mobile menu ---------- */
  (function navMenu() {
    const dds = $$('.dd', nav), burger = $('#burger');
    const hover = matchMedia('(hover:hover) and (min-width:961px)');
    const close = (except) => dds.forEach(d => { if (d !== except) { d.classList.remove('is-open'); $('.dd__btn', d).setAttribute('aria-expanded', 'false'); } });
    dds.forEach(d => {
      const btn = $('.dd__btn', d); let t;
      const open = () => { close(d); d.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); };
      btn.addEventListener('click', () => d.classList.contains('is-open') ? close() : open());
      d.addEventListener('pointerenter', () => { if (hover.matches) { clearTimeout(t); open(); } });
      d.addEventListener('pointerleave', () => { if (hover.matches) t = setTimeout(() => close(), 160); });
      d.addEventListener('keydown', e => { if (e.key === 'Escape') { close(); btn.focus(); } });
    });
    document.addEventListener('click', e => { if (!nav.contains(e.target)) close(); });
    const setMenu = (on) => { nav.classList.toggle('menu-open', on); burger.setAttribute('aria-expanded', on); burger.setAttribute('aria-label', on ? 'Close menu' : 'Open menu'); document.body.style.overflow = on ? 'hidden' : ''; };
    burger.addEventListener('click', () => setMenu(!nav.classList.contains('menu-open')));
    $$('.menu a', nav).forEach(a => a.addEventListener('click', () => { setMenu(false); close(); }));
  })();

  /* ---------- Footer signup (validate only) ---------- */
  const fs = $('#footSignup');
  if (fs) fs.addEventListener('submit', e => {
    const inp = $('#footEmail'), msg = $('#footMsg');
    const ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(inp.value.trim());
    if (!ok || !fs.getAttribute('action')) {
      e.preventDefault();
      msg.classList.toggle('is-err', !ok);
      msg.textContent = ok ? 'You\u2019re on the list.' : 'Please enter a valid email address.';
      if (ok) inp.value = '';
    }
  });

  /* ---------- Motion ---------- */
  const g = window.gsap;
  if (!g || reduce) { $$('.reveal').forEach(el => el.style.opacity = 1); return; }
  g.registerPlugin(window.ScrollTrigger);
  g.from('.thero__copy > *', { y: 20, opacity: 0, duration: .9, stagger: .07, ease: 'power3.out' });
  if (document.querySelector('.ahero')) { g.from('.ahero__inner > *', { y: 22, opacity: 0, duration: .9, stagger: .07, ease: 'power3.out' }); g.to('.ahero__bg', { yPercent: 8, ease: 'none', scrollTrigger: { trigger: '.ahero', start: 'top top', end: 'bottom top', scrub: true } }); }
  g.from('.thero__pols .tpol', { y: 60, opacity: 0, duration: 1.1, stagger: .12, ease: 'power3.out', delay: .15 });
  $$('.reveal').forEach(el => g.fromTo(el, { y: 28, opacity: 0 }, { y: 0, opacity: 1, duration: .9, ease: 'power3.out', scrollTrigger: { trigger: el, start: 'top 88%', once: true } }));
  $$('.tperson__media > img:first-child').forEach(img => g.fromTo(img, { yPercent: -4 }, { yPercent: 4, ease: 'none', scrollTrigger: { trigger: img, start: 'top bottom', end: 'bottom top', scrub: true } }));
})();